import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { TowAttemptService } from '@services/tow-attempt.service';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import * as actions from './actions';

@Injectable()
export class TowAttemptStoreEffects {
    constructor(
        private actions$: Actions,
        private towAttemptService: TowAttemptService
    ) {}

    // Save Tow Attempt
    saveTowAttempt$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actions.saveTowAttemptRequest),
            switchMap(action => this.towAttemptService.saveTowAttempt(action.towAttempt).pipe(
                map(towAttempt => actions.saveTowAttemptSuccess({ towAttempt })),
                catchError(error => of(actions.saveTowAttemptFailure({ error })))
            ))
        )
    );
}
